import React from 'react';
import PropTypes from 'prop-types';
import {detect} from 'detect-browser';
import styles from './index.css';

const browser = detect();

export default class SvgText extends React.Component {
  static propTypes = {
    children: PropTypes.array,
    className: PropTypes.string,
    style: PropTypes.object,
    text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textRef: PropTypes.func,
    transform: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    children: null,
    className: '',
    style: {},
    text: '',
    textRef: () => null,
    transform: '',
    x: 0,
    y: 0,
  };

  state = {
    dy: null,
  };

  componentDidMount() {
    this.setDy(browser && browser.name);
  }

  setDy(browserName) {
    // SVG vertical text layout is accomplished
    // in CSS using the dominant-baseline property.
    // Lamentably, this property is not supported
    // by any version of IE or Edge. dominant-baseline is
    // very convenient, and it seems a shame to
    // avoid using it just because of IE/Edge. So:
    // 1. Detect the browser. If it's IE/Edge--
    // 2. Get computed styles for this element.
    // 3. If dominant-baseline is set for the element,
    // simulate its effect by setting an offset,
    // using the SVG text element's dy attribute.
    // text-before-edge and central are the only
    // values simulated at this point.
    // Getting computed styles causes one reflow, and
    // then if dy is set, React will re-render and trigger
    // another. So yes, this is an expensive operation,
    // but it does only happen once, when a component mounts.
    if (browserName === 'ie' || browserName === 'edge') {
      const style = window.getComputedStyle(this._node, null);
      if (style.dominantBaseline === 'central') {
        this.setState({
          dy: '.35em',
        });
      }
      if (style.dominantBaseline === 'text-before-edge') {
        this.setState({
          dy: '1em',
        });
      }
    }
  }

  render() {
    return (
      <text
        className={this.props.className || styles.SvgText}
        dy={this.state.dy}
        ref={(node) => {
          this._node = node;
          this.props.textRef(node);
        }}
        style={this.props.style}
        transform={this.props.transform}
        x={this.props.x}
        y={this.props.y}>
        {this.props.children || this.props.text}
      </text>
    );
  }
}
